import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useFilterRecentlyModified } from "@hooks/use-catalog";
import Input from "@components/core/Input";

function FilterCheckbox({
  label = "",
  filterType = "",
  filterSectionKey = "",
  item = {},
  refine = () => {},
}) {
  const filterRecentlyModified = useFilterRecentlyModified();

  function handleClick() {
    const eventData = { button: "filter", filter: filterType, value: item.label };
    ahoy("$click", eventData);
    analytics.track("$click", eventData);

    filterRecentlyModified(filterSectionKey);

    refine(item.value);
  }

  return (
    <Input
      type="checkbox"
      label={`${label} (${item.count})`}
      checked={item.isRefined}
      onClick={handleClick}
      readOnly
      className="p-3 bg-white border-bottom"
      rightToLeft
      fullWidth
    />
  );
}

export default FilterCheckbox;
